import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TermsOfUse.module.scss';

const TermsOfUse: React.FC = () => {
    const { t } = useTranslation();

    const termsTextParagraphs = t('TermsPage.termsOfUseText').split('\\n\\n');

    return (
        <div className={styles.container}>
            <h1 className={styles.pageTitle}>
                {t('TermsPage.termsOfUse')}
            </h1>

            <div className={styles.contentContainer}>
                {termsTextParagraphs.map((paragraph, index) => (
                    <p key={index} className={styles.termsParagraph}>
                        {paragraph}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default TermsOfUse;